export enum ClientName {
	TM = "tm2",
	TM_ADMIN = "tmadmin",
	TM_ORMCO = "tmormco",
	CA_VIEWER = "ca-viewer"
}
